export default {
    'daily-report': 'التقرير اليومي',
    'visits': 'الزيارات'
}